import { render, staticRenderFns } from "./RptCitationAnalysis.vue?vue&type=template&id=70b5b098&scoped=true&"
import script from "./RptCitationAnalysis.vue?vue&type=script&lang=js&"
export * from "./RptCitationAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5b098",
  null
  
)

export default component.exports